import { Card, Col, Modal, Radio, Row, Tooltip } from 'antd';
import React, { useState } from 'react';
import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';
import { Action, DropdownAction, errorCatch, Field, JSXMap, Model, POST, QueryDetail, QueryOrder, QueryParam, updateInArray, useAuth } from 'fennec-ui';
import { CollectionServer } from 'fennec-ui';
import PopolnenieScheta from '../../forms/PopolnenieScheta';
import VivodSoScheta from '../../forms/VivodSoScheta';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import User from '../../../common/User';
import OstatkiPoSchetu from '../../forms/OstatkiPoSchetu';
import FederationadministratorEventsOrdersAll from '../FederationadministratorEventsOrdersAll';
import PageLayout from '../../components/PageLayout';
import FilterFieldLabel from '../../components/FilterFieldLabel';
import Icofont from 'react-icofont';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

var _ = require('lodash');

const useStyles = createUseStyles({
    item: {
        padding: "5px 10px",
        display: "flex",
        cursor: "pointer",
        '&:hover': {
            backgroundColor: "#f9f9f9"
        }
    },
})

function getCurrencyValue(value, color) {
    if (!value) {
        let zero = 0;
        return (<span style={{ color: "grey" }}>
            {(Number(zero?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
    if (color) {
        return (<span style={{ color: color }}>
            {(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
    if (value >= 0) {
        return (<span style={{ color: "rgb(63, 134, 0)" }}>
            {(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
    if (value < 0) {
        return (<span style={{ color: "red" }}>
            {(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
}

function DvizhenieListItem(props) {
    const classes = useStyles();
    const { item, fill, extraColumn } = props;
    const color = (item) => {
        if (!item?.ukhodID && item?.prikhodID) {
            return "bg-green"
        } else if (item?.ukhodID && !item?.prikhodID) {
            return "bg-red"
        } else if (item?.ukhodID && item?.prikhodID) {
            return "bg-grey light-10"
        }
    }
    return (
        <div className={`bg ${(fill) ? color(item) : ""}`} key={item.ID} style={{ width: "100%", textAlign: "left" }}>
            <div className={classes.item}>
                <div style={{ flex: "0 0 25px" }}>
                    {(!item?.ukhodID && item?.prikhodID) && <Icofont icon="caret-up" style={{ color: "green" }} />}
                    {(item?.ukhodID && !item?.prikhodID) && <Icofont icon="caret-down" style={{ color: "red" }} />}
                    {(item?.ukhodID && item?.prikhodID) && <Icofont icon="rounded-expand" rotate='90' style={{ color: "grey" }} />}
                </div>
                <div style={{ flex: "1 1 auto", fontWeight: "400", fontSize: "14px" }}>
                    <div>
                        {(!item?.ukhodID && item?.prikhodID) && <span>
                            Зачисление денежных средств {(item?.osnovanie?.ownerType == 'ekvairing') && <span>(эквайринг)</span>}
                            <Icofont icon="long-arrow-right" />
                            <span><span>№{item?.prikhodNomer}</span> <span style={{ color: "#6a6a6a" }}>{item?.prikhod?.accountInfo?.vladelets}</span></span>
                        </span>}
                        {(item?.ukhodID && !item?.prikhodID) && <span>
                            <span><span>№{item?.ukhodNomer}</span> <span style={{ color: "#6a6a6a" }}>{item?.ukhod?.accountInfo?.vladelets}</span></span>
                            <Icofont icon="long-arrow-right" />
                            Вывод денежных средств
                        </span>}

                        {(item?.ukhodID && item?.prikhodID) && <span>
                            <span><span>№{item?.ukhodNomer}</span> <span style={{ color: "#6a6a6a" }}>{item?.ukhod?.accountInfo?.vladelets}</span></span>
                            <Icofont icon="long-arrow-right" />
                            <span><span>№{item?.prikhodNomer}</span> <span style={{ color: "#6a6a6a" }}>{item?.prikhod?.accountInfo?.vladelets}</span></span>
                        </span>}
                    </div>
                    <div style={{ fontWeight: "300", fontSize: "12px" }}>{item?.opisanie} </div>
                </div>
                <div style={{ flex: "0 0 150px" }}>
                    <div style={{ alignSelf: "flex-start", color: "#7c7c7c", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "400", fontSize: "11px" }}>
                        Сумма:
                    </div>
                    <div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "14px" }}>
                        {getCurrencyValue(item?.summa, "black")}
                    </div>
                </div>
                {extraColumn}
            </div>
        </div>
    )
}

function NomerAkkaunta(props) {
    const { item, trigger } = props;
    const auth = useAuth();
    if (!item) return <></>;
    return (<Action
        auth={auth}
        title="Отчет по остаткам"
        readonly={true}
        noAntForm={true}
        mode="func"
        trigger={trigger || ((click) => (<span onClick={event => {
            event.stopPropagation();
            click();
        }}>№{item?.nomerAkkaunta}</span>))}
        titles={{
            subheader: <div style={{ paddingBottom: "15px" }}>
                <div>№{item?.nomerAkkaunta} </div>
                <div key={item.ID} style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                    {item?.akkauntType.opisanie}: {item?.accountInfo.vladelets}
                </div>
            </div>
        }}
        modal={{
            width: "940px",
        }}
        object={item}
        location="fedadmin"
        form={OstatkiPoSchetu}
        action={(values, unlock, close, { collection, setCollection }) => { }}
    />)
}
function DvizhenieRow({ auth, item, idx, setCollectionItem, modelActions, collection, setCollection }) {
    const [collapsed, setCollapsed] = useState(true);

    const rowColor = (xitem) => {
        if (!xitem?.ukhodID && xitem?.prikhodID) {
            return "bg-green"
        } else if (xitem?.ukhodID && !xitem?.prikhodID) {
            return "bg-red"
        } else if (xitem?.ukhodID && xitem?.prikhodID) {
            return "bg-grey"
        } else {
            return "bg-grey"
        }
    }
    const summColor = (xitem) => {
        if (!xitem?.ukhodID && xitem?.prikhodID) {
            return "green"
        } else if (xitem?.ukhodID && !xitem?.prikhodID) {
            return "red"
        } else if (xitem?.ukhodID && xitem?.prikhodID) {
            return "black"
        } else {
            return "black"
        }
    }
    // console.log(item);
    // useEffect(() => {
    //     if (!collapsed) {
    //         READWITH(auth, item.dvizhenieDeneg.osnovanie.ownerType, [
    //             QueryParam("w-ID", item.dvizhenieDeneg.osnovanie.ownerID)
    //         ], ({ data }) => {
    //             console.log(data);
    //         }, errorCatch)
    //     }
    // }, [collapsed])
    return (<React.Fragment key={idx}>
        <tr key={idx} className={'pointer'} onClick={() => {
            setCollapsed(o => !o);
        }}>
            <td className={`fill`}><div className={`bg ${rowColor(item)}`} style={{ minWidth: "25px", maxWidth: "25px" }}>
                {(collapsed) && <i className="fa fa-plus-square-o"></i>}
                {(!collapsed) && <i className="fa fa-minus-square-o"></i>}
            </div></td>
            <td className={`fill`}>
                <div className={`bg ${rowColor(item)}`}>
                    <div>{dayjs(item?.CreatedAt).format("DD.MM.YYYY HH:mm:ss")}</div>
                </div>
            </td>
            <td className={`fill`}><div className={`bg ${rowColor(item)}`} style={{ textAlign: "left" }}>
                <Tooltip title={
                    <div>
                        <div style={{ fontSize: "13px" }}>{(item?.ukhodID) ? "№" : ""}{item?.ukhodNomer} <span style={{ fontSize: "12px", fontStyle: "italic" }}>{item?.ukhod?.akkauntType?.opisanie}</span></div>
                        <div style={{ fontSize: "12px", textOverflow: "ellipsis", overflow: "hidden" }}>{item?.ukhod?.accountInfo?.vladelets}</div>
                    </div>
                }>
                    <div>
                        <div style={{ fontSize: "13px", color: "black" }}>{(item?.ukhodID) ? "№" : ""}{item?.ukhodNomer} <span style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>{item?.ukhod?.akkauntType?.opisanie}</span></div>
                        <div style={{ fontSize: "12px", color: "#6a6a6a", textOverflow: "ellipsis", overflow: "hidden" }}>{item?.ukhod?.accountInfo?.vladelets}</div>
                    </div>
                </Tooltip>

            </div></td>
            <td className={`fill`}><div className={`bg ${rowColor(item)}`}>{getCurrencyValue(item?.summa, summColor(item))}</div></td>
            <td className={`fill`}><div className={`bg ${rowColor(item)}`} style={{ textAlign: "left" }}>
                <Tooltip title={
                    <div>
                        <div style={{ fontSize: "13px" }}>{(item?.prikhodID) ? "№" : ""}{item?.prikhodNomer} <span style={{ fontSize: "12px", fontStyle: "italic" }}>{item?.prikhod?.akkauntType?.opisanie}</span></div>
                        <div style={{ fontSize: "12px", textOverflow: "ellipsis", overflow: "hidden" }}>{item?.prikhod?.accountInfo?.vladelets}</div>
                    </div>
                }>
                    <div>
                        <div style={{ fontSize: "13px", color: "black" }}>{(item?.prikhodID) ? "№" : ""}{item?.prikhodNomer} <span style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>{item?.prikhod?.akkauntType?.opisanie}</span></div>
                        <div style={{ fontSize: "12px", color: "#6a6a6a", textOverflow: "ellipsis", overflow: "hidden" }}>{item?.prikhod?.accountInfo?.vladelets}</div>
                    </div>
                </Tooltip>

            </div></td>
            {modelActions && <td className={`fill`} onClick={(e) => { e.stopPropagation() }}>
                <DropdownAction
                    style={{ padding: "0" }}
                    button={() => (<div className={`bg ${rowColor(item)} pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                        <i className="fa fa-ellipsis-h"></i>
                    </div>)}
                    items={modelActions(item, idx)?.map((e, idx) => ({
                        key: e.key || idx,
                        auth: auth,
                        mode: "MenuItem",
                        object: item,
                        collection: collection,
                        setCollection: setCollection,
                        ...e
                    }))} />
            </td>}
        </tr>
        {(!collapsed) && <tr>
            <td colSpan={5} className={`fill`}>
                <div className="bg bg-orange" style={{ textAlign: "left", marginLeft: "25px" }}>
                    <div style={{ fontWeight: "300", textWrap: "wrap" }}>
                        {item?.opisanie}
                    </div>
                    <div style={{ fontWeight: "300", textWrap: "wrap" }}>
                        {item?.comment}
                    </div>
                </div>
            </td>
        </tr>}
    </React.Fragment>)
}

export default function FederationadministratorManagementDvizheniedeneg(props) {
    const classes = useStyles();
    const { auth } = props;
    const dispatch = useDispatch();
    const [view, setView] = useState(1)

    const filters = () => [
        {
            label: "Дата создания",
            name: "CreatedAt",
            filterType: "range",
            // func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: <FilterFieldLabel label="Владелец счетов" badge="or" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
            name: "vladeletsSchetov",
            // queryComparer:"swsim", // sim, wsim, swsim
            sort: false,
            filter: true,
            type: "func",
            render: (auth, item, value, onChange, onAfterChange, isChanged) => {
                return <Field auth={auth} item={{...item, type: "string"}} value={value} onChange={onChange} onAfterChange={onAfterChange} isChanged={isChanged} />;
            }
        },
        {
            label: "Тип счета списания",
            name: "ukhod.akkauntType",
            filterType: "group",
            queryFilter: [
                QueryDetail("model"),
                QueryOrder("code", "ASC"),
                QueryParam("w-neq-id", "7")
            ],
            display: (o) => o.opisanie,
            sort: true,
            filter: true,
        },
        {
            label: "Номер счета списания",
            name: "ukhod.nomerAkkaunta",
            sort: true,
            filter: true,
        },
        {
            label: <FilterFieldLabel label="Владелец счета списания" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
            name: "ukhod.accountInfo.vladelets",
            // queryComparer:"swsim", // sim, wsim, swsim
            sort: true,
            filter: true,
        },
        {
            label: "Сумма операции",
            name: "summa",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Тип счета зачисления",
            name: "prikhod.akkauntType",
            filterType: "group",
            queryFilter: [
                QueryDetail("model"),
                QueryOrder("code", "ASC"),
                QueryParam("w-neq-id", "7")
            ],
            display: (o) => o.opisanie,
            sort: true,
            filter: true,
        },
        {
            label: "Номер счета зачисления",
            name: "prikhod.nomerAkkaunta",
            sort: true,
            filter: true,
        },
        {
            label: <FilterFieldLabel label="Владелец счета зачисления" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
            name: "prikhod.accountInfo.vladelets",
            // queryComparer:"swsim", // sim, wsim, swsim
            sort: true,
            filter: true,
        },
        // {
        //     label: "Номер счета",
        //     name: "nomerAkkaunta",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: <FilterFieldLabel label="Владелец" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
        //     name: "accountInfo.vladelets",
        //     // queryComparer:"swsim", // sim, wsim, swsim
        //     sort: true,
        //     filter: true,
        // },
    ];

    const render = (items, collection, setCollection, setCollectionItem, modelActions) => {
        if (view == 1) {
            return (<div>

                <div className='scrollable'>
                    <table className="table" style={{ fontSize: "13px" }}>
                        <thead>
                            <tr>
                                <th className={`wrap`} style={{ minWidth: "25px", maxWidth: "25px", width: "25px" }}></th>
                                <th className={`wrap`} style={{ minWidth: "55px", maxWidth: "55px" }}><div className='bg bg-grey dark-1'>Дата/время операции</div></th>
                                <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Счет списания</div></th>
                                <th className={`wrap`} style={{ minWidth: "60px", maxWidth: "60px" }}><div className='bg bg-grey dark-1'>Сумма операции</div></th>
                                <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Счет зачисления</div></th>
                                {modelActions && <th className={`wrap`} style={{ minWidth: "25px", maxWidth: "25px", width: "25px" }}></th>}
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px" }}>
                            {JSXMap(items, (item, oidx) => {
                                return (<DvizhenieRow key={oidx} auth={auth} item={item} idx={oidx} collection={collection} setCollection={setCollection} setCollectionItem={setCollectionItem} modelActions={modelActions} />)
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            )
        } else {
            return (<div>
                {JSXMap(items, (item, idx) => {
                    return (<DvizhenieListItem item={item} extraColumn={
                        <div style={{ flex: "0 0 35px", paddingLeft: "10px" }} onClick={(e) => { e.stopPropagation() }}>
                            <DropdownAction
                                style={{ padding: "0" }}
                                button={() => (<div className={`bg bg-grey pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                    <i className="fa fa-ellipsis-h"></i>
                                </div>)}
                                items={modelActions(item, idx)?.map((e, idx) => ({
                                    key: e.key || idx,
                                    auth: auth,
                                    mode: "MenuItem",
                                    object: item,
                                    collection: collection,
                                    setCollection: setCollection,
                                    ...e
                                }))} />
                        </div>
                    } />)
                })}
            </div>)
        }
    }

    return (
        <PageLayout>
            <div style={{ padding: "5px 10px", backgroundColor: "white", borderRadius: "4px" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ paddingBottom: "15px", fontSize: "18px" }}>Движения денег</div>
                    <div>
                        <Radio.Group defaultValue={view} size="small" onChange={(e) => setView(e?.target?.value)}>
                            <Radio.Button value={1}><i className="fa fa-table" style={{ fontSize: "12px" }}></i></Radio.Button>
                            <Radio.Button value={2}><i className="fa fa-list" style={{ fontSize: "12px" }}></i></Radio.Button>
                        </Radio.Group>
                    </div>
                </div>

                <CollectionServer
                    auth={auth}
                    name={"DvizheniyaDeneg"}
                    queryDetail={"collection"}
                    // source={"/api/fed/admin/akkaunti-polzovatelei"}
                    filters={filters}
                    size={"small"}
                    mode={"list"}
                    customRender={(items, {
                        collection,
                        setCollection,
                        setCollectionItem,
                        removeCollectionItem,
                        collectionActions,
                        modelActions,
                        update
                    }) => render(items, collection, setCollection, setCollectionItem, modelActions)}
                    collectionActions={() => [{
                        auth: auth,
                        action: (values, unlock, close, { collection, setCollection }) => {
                            POST(auth, `/api/fed/admin/dvizheniyadeneg/create`, { ...values },
                                ({ data }) => {
                                    setCollection(updateInArray(collection, data, true));
                                    close();
                                }, (err) => errorCatch(err, unlock)
                            );
                        },
                        title: "Новое движение",
                        modal: {
                            title: "Новое движение денег"
                        },
                        form: Model,
                        meta: [
                            {
                                label: <span><Icofont icon="caret-down" style={{ color: "red" }} /> Счет списания</span>,
                                name: "ukhod",
                                type: "object",
                                mode: "dialog",
                                modal: { width: "700px" },
                                count: () => { return 10 },
                                relation: {
                                    uiFilter: () => [
                                        {
                                            label: "Тип счета",
                                            name: "akkauntType",
                                            filterType: "group",
                                            queryFilter: [
                                                QueryDetail("model"),
                                                QueryOrder("code", "ASC"),
                                                QueryParam("w-neq-id", "7")
                                            ],
                                            display: (o) => o.opisanie,
                                            sort: true,
                                            filter: true,
                                        },
                                        {
                                            label: "Баланс счета",
                                            name: "ostatok",
                                            filterType: "range",
                                            func: ["min", "max"],
                                            sort: true,
                                            filter: true,
                                        },
                                        {
                                            label: "Номер счета",
                                            name: "nomerAkkaunta",
                                            sort: true,
                                            filter: true,
                                        },
                                        {
                                            label: <FilterFieldLabel label="Владелец" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
                                            name: "accountInfo.vladelets",
                                            // queryComparer:"swsim", // sim, wsim, swsim
                                            sort: true,
                                            filter: true,
                                        },
                                    ],
                                    suffix: (item) => {
                                        return getCurrencyValue(item?.ostatok)
                                    },
                                    displayString: (item) => {
                                        return (`№${item?.nomerAkkaunta} ${item?.akkauntType?.opisanie}: ${item?.accountInfo?.vladelets}`)
                                    },
                                    display: (item) => {
                                        return (
                                            <div key={item.ID} style={{ width: "100%" }}>
                                                <div className={classes.item}>
                                                    <div style={{ flex: "1 1 auto" }}>
                                                        <div>№{item?.nomerAkkaunta} </div>
                                                        <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                                                            {item?.akkauntType.opisanie}: {item?.accountInfo.vladelets}
                                                        </div>
                                                    </div>
                                                    <div style={{ flex: "0 0 150px" }}>
                                                        <div style={{ alignSelf: "flex-start", color: "#7c7c7c", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "400", fontSize: "11px" }}>
                                                            Баланс:
                                                        </div>
                                                        <div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "14px" }}>
                                                            {getCurrencyValue(item?.ostatok)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    },
                                    reference: { object: "Akkaunti", property: "ID", /*source: "/api/meropriyatiya/list/com"*/ },
                                    type: "many-one",
                                },
                                queryFilter: [
                                    QueryDetail("model"),
                                    QueryOrder("akkauntType.code", "ASC"),
                                    QueryOrder("createdat", "ASC"),
                                    QueryParam("w-neq-id", "7"),
                                ]
                            },
                            {
                                label: <span><Icofont icon="caret-up" style={{ color: "green" }} /> Счет зачисления</span>,
                                name: "prikhod",
                                type: "object",
                                mode: "dialog",
                                modal: { width: "700px" },
                                count: () => { return 10 },
                                relation: {
                                    uiFilter: () => [
                                        {
                                            label: "Тип счета",
                                            name: "akkauntType",
                                            filterType: "group",
                                            queryFilter: [
                                                QueryDetail("model"),
                                                QueryOrder("code", "ASC"),
                                                QueryParam("w-neq-id", "7")
                                            ],
                                            display: (o) => o.opisanie,
                                            sort: true,
                                            filter: true,
                                        },
                                        {
                                            label: "Баланс счета",
                                            name: "ostatok",
                                            filterType: "range",
                                            func: ["min", "max"],
                                            sort: true,
                                            filter: true,
                                        },
                                        {
                                            label: "Номер счета",
                                            name: "nomerAkkaunta",
                                            sort: true,
                                            filter: true,
                                        },
                                        {
                                            label: <FilterFieldLabel label="Владелец" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
                                            name: "accountInfo.vladelets",
                                            // queryComparer:"swsim", // sim, wsim, swsim
                                            sort: true,
                                            filter: true,
                                        },
                                    ],
                                    suffix: (item) => {
                                        return getCurrencyValue(item?.ostatok)
                                    },
                                    displayString: (item) => {
                                        return (`№${item?.nomerAkkaunta} ${item?.akkauntType?.opisanie}: ${item?.accountInfo?.vladelets}`)
                                    },
                                    display: (item) => {
                                        return (
                                            <div key={item.ID} style={{ width: "100%" }}>
                                                <div className={classes.item}>
                                                    <div style={{ flex: "1 1 auto" }}>
                                                        <div>№{item?.nomerAkkaunta} </div>
                                                        <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                                                            {item?.akkauntType.opisanie}: {item?.accountInfo.vladelets}
                                                        </div>
                                                    </div>
                                                    <div style={{ flex: "0 0 150px" }}>
                                                        <div style={{ alignSelf: "flex-start", color: "#7c7c7c", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "400", fontSize: "11px" }}>
                                                            Баланс:
                                                        </div>
                                                        <div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "14px" }}>
                                                            {getCurrencyValue(item?.ostatok)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    },
                                    reference: { object: "Akkaunti", property: "ID", /*source: "/api/meropriyatiya/list/com"*/ },
                                    type: "many-one",
                                },
                                queryFilter: [
                                    QueryDetail("model"),
                                    QueryOrder("akkauntType.code", "ASC"),
                                    QueryOrder("createdat", "ASC"),
                                    QueryParam("w-neq-id", "7"),
                                ]
                            },
                            {
                                label: "Сумма",
                                name: "summa",
                                type: "float",
                                min: 0.01,
                                validators: [
                                    {
                                        func: (value) => !!value,
                                        message: "Укажите сумму!"
                                    },
                                    {
                                        func: (value) => {
                                            return value >= 0.01;
                                        },
                                        message: "Значение не может быть меньше 0.01"
                                    }
                                ]
                            },
                            {
                                label: "Примечание",
                                name: "primechanie",
                                type: "text",
                            },
                        ],
                    }]}
                    modelActions={(item) => {
                        return [
                            {
                                title: "Создать обратное движение",
                                titles: {
                                    subheader: (<div style={{ border: "1px solid rgb(223 223 223 / 88%)", borderRadius: "6px", marginBottom: "5px" }}>
                                        <DvizhenieListItem item={item} fill={true} />
                                    </div>)
                                },
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    POST(auth, `/api/fed/admin/dvizheniyadeneg/create`, { ...values },
                                        ({ data, account }) => {
                                            setCollection(updateInArray(collection, data, true));
                                            close();
                                        },
                                        (err) => errorCatch(err, unlock)
                                    );
                                },
                                object: {
                                    ...item,
                                    ukhod: item?.prikhod,
                                    ukhodID: item?.prikhodID,
                                    prikhod: item?.ukhod,
                                    prikhodID: item?.ukhodID,
                                    summa: item?.summa,
                                    primechanie: `Отмена движения №${item?.ID} от ${dayjs(item?.CreatedAt).format("DD.MM.YYYY HH:mm:ss")} на сумму ${(Number(item?.summa?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб. ${item?.opisanie}`,
                                },
                                options: {
                                    initialValues: {
                                        ukhod: item?.prikhod,
                                        ukhodID: item?.prikhodID,
                                        prikhod: item?.ukhod,
                                        prikhodID: item?.ukhodID,
                                        summa: item?.summa,
                                        primechanie: `Отмена движения №${item?.ID} от ${dayjs(item?.CreatedAt).format("DD.MM.YYYY HH:mm:ss")} на сумму ${(Number(item?.summa?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб. ${item?.opisanie}`,
                                    },
                                },
                                modal: { width: "600px" },
                                form: Model,
                                meta: [
                                    {
                                        label: <span><Icofont icon="caret-down" style={{ color: "red" }} /> Счет списания</span>,
                                        name: "ukhod",
                                        type: "object",
                                        mode: "dialog",
                                        modal: { width: "700px" },
                                        count: () => { return 10 },
                                        view: {
                                            disabled: true,
                                        },
                                        relation: {
                                            uiFilter: () => [
                                                {
                                                    label: "Тип счета",
                                                    name: "akkauntType",
                                                    filterType: "group",
                                                    queryFilter: [
                                                        QueryDetail("model"),
                                                        QueryOrder("code", "ASC"),
                                                        QueryParam("w-neq-id", "7")
                                                    ],
                                                    display: (o) => o.opisanie,
                                                    sort: true,
                                                    filter: true,
                                                },
                                                {
                                                    label: "Баланс счета",
                                                    name: "ostatok",
                                                    filterType: "range",
                                                    func: ["min", "max"],
                                                    sort: true,
                                                    filter: true,
                                                },
                                                {
                                                    label: "Номер счета",
                                                    name: "nomerAkkaunta",
                                                    sort: true,
                                                    filter: true,
                                                },
                                                {
                                                    label: <FilterFieldLabel label="Владелец" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
                                                    name: "accountInfo.vladelets",
                                                    // queryComparer:"swsim", // sim, wsim, swsim
                                                    sort: true,
                                                    filter: true,
                                                },
                                            ],
                                            suffix: (item) => {
                                                return getCurrencyValue(item?.ostatok)
                                            },
                                            displayString: (item) => {
                                                return (`№${item?.nomerAkkaunta} ${item?.akkauntType?.opisanie}: ${item?.accountInfo?.vladelets}`)
                                            },
                                            display: (item) => {
                                                return (
                                                    <div key={item.ID} style={{ width: "100%" }}>
                                                        <div className={classes.item}>
                                                            <div style={{ flex: "1 1 auto" }}>
                                                                <div>№{item?.nomerAkkaunta} </div>
                                                                <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                                                                    {item?.akkauntType.opisanie}: {item?.accountInfo.vladelets}
                                                                </div>
                                                            </div>
                                                            <div style={{ flex: "0 0 150px" }}>
                                                                <div style={{ alignSelf: "flex-start", color: "#7c7c7c", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "400", fontSize: "11px" }}>
                                                                    Баланс:
                                                                </div>
                                                                <div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "14px" }}>
                                                                    {getCurrencyValue(item?.ostatok)}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            },
                                            reference: { object: "Akkaunti", property: "ID", /*source: "/api/meropriyatiya/list/com"*/ },
                                            type: "many-one",
                                        },
                                        queryFilter: [
                                            QueryDetail("model"),
                                            QueryOrder("akkauntType.code", "ASC"),
                                            QueryOrder("createdat", "ASC"),
                                            QueryParam("w-neq-id", "7"),
                                        ]
                                    },
                                    {
                                        label: <span><Icofont icon="caret-up" style={{ color: "green" }} /> Счет зачисления</span>,
                                        name: "prikhod",
                                        type: "object",
                                        mode: "dialog",
                                        modal: { width: "700px" },
                                        count: () => { return 10 },
                                        view: {
                                            disabled: true,
                                        },
                                        relation: {
                                            uiFilter: () => [
                                                {
                                                    label: "Тип счета",
                                                    name: "akkauntType",
                                                    filterType: "group",
                                                    queryFilter: [
                                                        QueryDetail("model"),
                                                        QueryOrder("code", "ASC"),
                                                        QueryParam("w-neq-id", "7")
                                                    ],
                                                    display: (o) => o.opisanie,
                                                    sort: true,
                                                    filter: true,
                                                },
                                                {
                                                    label: "Баланс счета",
                                                    name: "ostatok",
                                                    filterType: "range",
                                                    func: ["min", "max"],
                                                    sort: true,
                                                    filter: true,
                                                },
                                                {
                                                    label: "Номер счета",
                                                    name: "nomerAkkaunta",
                                                    sort: true,
                                                    filter: true,
                                                },
                                                {
                                                    label: <FilterFieldLabel label="Владелец" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
                                                    name: "accountInfo.vladelets",
                                                    // queryComparer:"swsim", // sim, wsim, swsim
                                                    sort: true,
                                                    filter: true,
                                                },
                                            ],
                                            suffix: (item) => {
                                                return getCurrencyValue(item?.ostatok)
                                            },
                                            displayString: (item) => {
                                                return (`№${item?.nomerAkkaunta} ${item?.akkauntType?.opisanie}: ${item?.accountInfo?.vladelets}`)
                                            },
                                            display: (item) => {
                                                return (
                                                    <div key={item.ID} style={{ width: "100%" }}>
                                                        <div className={classes.item}>
                                                            <div style={{ flex: "1 1 auto" }}>
                                                                <div>№{item?.nomerAkkaunta} </div>
                                                                <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                                                                    {item?.akkauntType.opisanie}: {item?.accountInfo.vladelets}
                                                                </div>
                                                            </div>
                                                            <div style={{ flex: "0 0 150px" }}>
                                                                <div style={{ alignSelf: "flex-start", color: "#7c7c7c", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "400", fontSize: "11px" }}>
                                                                    Баланс:
                                                                </div>
                                                                <div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "14px" }}>
                                                                    {getCurrencyValue(item?.ostatok)}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            },
                                            reference: { object: "Akkaunti", property: "ID", /*source: "/api/meropriyatiya/list/com"*/ },
                                            type: "many-one",
                                        },
                                        queryFilter: [
                                            QueryDetail("model"),
                                            QueryOrder("akkauntType.code", "ASC"),
                                            QueryOrder("createdat", "ASC"),
                                            QueryParam("w-neq-id", "7"),
                                        ]
                                    },
                                    {
                                        label: "Сумма",
                                        name: "summa",
                                        type: "float",
                                        view: {
                                            disabled: true,
                                        },
                                        min: 0.01,
                                        validators: [
                                            {
                                                func: (value) => !!value,
                                                message: "Укажите сумму!"
                                            },
                                            {
                                                func: (value) => {
                                                    return value >= 0.01;
                                                },
                                                message: "Значение не может быть меньше 0.01"
                                            }
                                        ]
                                    },
                                    {
                                        label: "Примечание",
                                        name: "primechanie",
                                        type: "text",
                                    },
                                ],
                            },
                            // {
                            //     title: "Пополнение счета",
                            //     titles: {
                            //         subheader: <div style={{ paddingBottom: "15px" }}>
                            //             <div>№{item?.nomerAkkaunta} </div>
                            //             <div key={item.ID} style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                            //                 {item?.akkauntType.opisanie}: {item?.accountInfo.vladelets}
                            //             </div>
                            //         </div>
                            //     },
                            //     object: item,
                            //     form: PopolnenieScheta,
                            //     action: (values, unlock, close, { collection, setCollection }) => {
                            //         POST(auth, '/api/fed/admin/popolneniescheta', { ...values },
                            //             ({ data, account }) => {
                            //                 setCollection(updateInArray(collection, {
                            //                     ...item,
                            //                     ostatok: account.ostatok
                            //                 }));
                            //                 close();
                            //             },
                            //             (err) => errorCatch(err, unlock)
                            //         );
                            //     },
                            // },
                            // {
                            //     title: "Списание со счета",
                            //     titles: {
                            //         subheader: <div style={{ paddingBottom: "15px" }}>
                            //             <div>№{item?.nomerAkkaunta} </div>
                            //             <div key={item.ID} style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                            //                 {item?.akkauntType.opisanie}: {item?.accountInfo.vladelets}
                            //             </div>
                            //         </div>
                            //     },
                            //     object: item,
                            //     form: VivodSoScheta,
                            //     action: (values, unlock, close, { collection, setCollection }) => {
                            //         if (item && (item.ostatok - values.summa) < 0) {
                            //             Modal.confirm({
                            //                 title: 'Отрицательный баланс!',
                            //                 icon: <ExclamationCircleOutlined />,
                            //                 okText: "Продолжить",
                            //                 cancelText: "Отмена",
                            //                 content: 'Выполняемая операция приведет к отрицательному остатку на счете! Продолжить?',
                            //                 onOk() {
                            //                     POST(auth, '/api/fed/admin/vivodsoscheta', { ...values },
                            //                         ({ data, account }) => {
                            //                             setCollection(updateInArray(collection, {
                            //                                 ...item,
                            //                                 ostatok: account.ostatok
                            //                             }));
                            //                             close();
                            //                         },
                            //                         (err) => errorCatch(err, unlock)
                            //                     );
                            //                 },
                            //                 onCancel() {
                            //                     unlock()
                            //                 },
                            //             });
                            //         } else {
                            //             POST(auth, '/api/fed/admin/vivodsoscheta', { ...values },
                            //                 ({ data, account }) => {
                            //                     setCollection(updateInArray(collection, {
                            //                         ...item,
                            //                         ostatok: account.ostatok
                            //                     }));
                            //                     close();
                            //                 },
                            //                 (err) => errorCatch(err, unlock)
                            //             );
                            //         }
                            //     },
                            // },
                            // {
                            //     title: "Отчет по остаткам",
                            //     readonly: true,
                            //     noAntForm: true,
                            //     titles: {
                            //         subheader: <div style={{ paddingBottom: "15px" }}>
                            //             <div>№{item?.nomerAkkaunta} </div>
                            //             <div key={item.ID} style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                            //                 {item?.akkauntType.opisanie}: {item?.accountInfo.vladelets}
                            //             </div>
                            //         </div>
                            //     },
                            //     modal: {
                            //         width: "940px",
                            //     },
                            //     object: item,
                            //     form: OstatkiPoSchetu,
                            //     action: (values, unlock, close, { collection, setCollection }) => { },
                            // },
                        ]
                    }}
                />
            </div>
        </PageLayout>

    );
}
